// The list bullet settings (`User.convert_list_bullets`, `migrate_bullet_lists`, `list_bullet_style`; backend `bot/list_bullets.py`).
export const BULLET_STYLES = ['-', '*', '•'] as const
export type BulletStyle = (typeof BULLET_STYLES)[number]

export interface BulletSettings {
  convert_list_bullets: boolean
  migrate_bullet_lists: boolean
  list_bullet_style: BulletStyle
}

// "Still convert •" only matters while converting everything is off.
export function showMigrate(settings: BulletSettings): boolean {
  return !settings.convert_list_bullets
}

// The style is used if either toggle is on; it keeps its value while both are off.
export function styleEnabled(settings: BulletSettings): boolean {
  return settings.convert_list_bullets || settings.migrate_bullet_lists
}

// `•` is not a Markdown list character.
export function showBulletWarning(settings: BulletSettings): boolean {
  return settings.list_bullet_style === '•'
}
